import Button from './Button'
import Grid from './Grid'
import GridCell from './GridCell'
import GridContainer from './GridContainer'
import SelectField from './SelectField'
import TextField from './TextField'
import TextFieldHelperText from './TextFieldHelperText'

export default {
  install (Vue, options) {
    Vue.component('mdc-button', Button)
    Vue.component('mdc-grid', Grid)
    Vue.component('mdc-grid-cell', GridCell)
    Vue.component('mdc-grid-container', GridContainer)
    Vue.component('mdc-select-field', SelectField)
    Vue.component('mdc-text-field', TextField)
    Vue.component('mdc-text-field-helper-text', TextFieldHelperText)
  }
}
